import type DatePickerProperties from "./DatePicker.properties.ts";
import { useIsDesktopDevice } from "../../tools/hooks/useIsDesktopDevice.ts";
import { useIsMobileDevice } from "../../tools/hooks/useIsMobileDevice.ts";
import DatePickerMobileView from "./mobile/DatePicker.mobile.view.tsx";
import DatePickerDesktopView from "./desktop/DatePicker.desktop.view.tsx";

export default function DatePickerView(props: DatePickerProperties) {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <DatePickerMobileView {...props} />}
      {isDesktop && <DatePickerDesktopView {...props} />}
    </>
  );
}
